import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InventoryPageRoutingModule } from './inventory-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { InventoryLandingOptionsModalComponent } from './components/inventory-landing-options-modal/inventory-landing-options-modal.component';
import { InventoryPage } from './inventory.page';
import { OtherInventoryActionsComponent } from './components/other-inventory-actions/other-inventory-actions.component';
import { InventoryCompleteDeleteModalComponent } from './pages/inventory-worksheet/components/inventory-complete-delete-modal/inventory-complete-delete-modal.component';
import { CostReportModalComponent } from './components/cost-report-modal/cost-report-modal.component';
import { DownloadInventoryModalComponent } from './components/download-inventory-modal/download-inventory-modal.component';
import { ExtendedCostReportModalComponent } from './components/extended-cost-report-modal/extended-cost-report-modal.component';
import { SelectableInventoryComponent } from './components/selectable-inventory/selectable-inventory.component';
import { SelectableInventoryListComponent } from './components/selectable-inventory-list/selectable-inventory-list.component';
import { MobileSelectableInventoryListComponent } from './components/mobile-selectable-inventory-list/mobile-selectable-inventory-list.component';
import { InventoryLandingSkeletonComponent } from './components/inventory-landing-skeleton/inventory-landing-skeleton.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
    InventoryPageRoutingModule,
  ],
  declarations: [
    InventoryPage,
    OtherInventoryActionsComponent,
    InventoryLandingOptionsModalComponent,
    InventoryCompleteDeleteModalComponent,
    CostReportModalComponent,
    ExtendedCostReportModalComponent,
    SelectableInventoryListComponent,
    MobileSelectableInventoryListComponent,
    DownloadInventoryModalComponent,
    InventoryLandingSkeletonComponent,
  ],
  providers: [DatePipe],
})
export class InventoryPageModule {}
